import { Directive, HostListener, ElementRef, Input, Output, EventEmitter } from '@angular/core';
import { AppConstants } from '../shared/constants/app.constants';

@Directive({
  selector: '[TipoDocumento]'
})
export class TipoDocumentoDirective {
  teclaAnterior: string = "";
  contPunto: number = 0;
  @Input() TipoDocumento: string;
  @Input() NumeroDocumento: string;
  @Output() numeroDocumentoMsg: EventEmitter<object> = new EventEmitter<object>();

  constructor(private element: ElementRef) { }

  @HostListener('focusout', ['$event'])
  onKeypressHandler(event: any) {

    if (event.currentTarget.id != "numeroDocumento") {
      if (event.currentTarget.value == AppConstants.TipoDocumentoSelect.DNI) {
        if (this.TipoDocumento != '' && this.TipoDocumento.length != 8) {
          this.numeroDocumentoMsg.emit({ msg: 'Debe ingresar 8 dígitos', maxlength: 8 });
        } else {
          this.limpiarMsg(8);
        }
      } else if (event.currentTarget.value == AppConstants.TipoDocumentoSelect.CE) {
        if (this.TipoDocumento != '' && this.TipoDocumento.length != 11) {
          this.numeroDocumentoMsg.emit({ msg: 'Debe ingresar 11 dígitos', maxlength: 11 })
        } else {
          this.limpiarMsg(11);
        }
      } else if (event.currentTarget.value == AppConstants.TipoDocumentoSelect.PAS) {
        if (this.TipoDocumento != '' && this.TipoDocumento.length != 10) {
          this.numeroDocumentoMsg.emit({ msg: 'Debe ingresar 10 dígitos', maxlength: 10 });
        }
        else {
          this.limpiarMsg(10);
        }
      } else {
        this.numeroDocumentoMsg.emit({ msg: '', maxlength: 8 });
      }
    } else {
      if (this.TipoDocumento == AppConstants.TipoDocumentoSelect.DNI) {
        if (event.currentTarget.value != '' && event.currentTarget.value.length != 8) {
          this.numeroDocumentoMsg.emit({ msg: 'Debe ingresar 8 dígitos', maxlength: 8 });
        }
        else {
          this.limpiarMsg(8);
        }
      } else if (this.TipoDocumento == AppConstants.TipoDocumentoSelect.CE) {
        if (event.currentTarget.value != '' && event.currentTarget.value.length != 11) {
          this.numeroDocumentoMsg.emit({ msg: 'Debe ingresar 11 dígitos', maxlength: 11 })
        }
        else {
          this.limpiarMsg(11);
        }
      } else if (this.TipoDocumento == AppConstants.TipoDocumentoSelect.PAS) {
        if (event.currentTarget.value != '' && event.currentTarget.value.length != 10) {
          this.numeroDocumentoMsg.emit({ msg: 'Debe ingresar 10 dígitos', maxlength: 10 });
        }
        else {
          this.limpiarMsg(10);
        }
      } else {
        this.numeroDocumentoMsg.emit({ msg: '', maxlength: 8 });
      }
    }    
  }

  limpiarMsg(maxLegt) {
    this.numeroDocumentoMsg.emit({ msg: '', maxlength: maxLegt });
  }
}
